import { render } from "./RequestPath.view.vue?vue&type=template&id=31019828"
import script from "./RequestPath.view.vue?vue&type=script&lang=js"
export * from "./RequestPath.view.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__